'use client';

import { useParams } from 'next/navigation';
import { getPrice } from 'modules/formatter';
import { IPrice } from 'modules/formatter/types';

export const usePrice = (
  value?: number | null,
  currencyCode?: string,
): IPrice | null => {
  const { locale } = useParams();

  if ((!value && value !== 0) || !currencyCode) {
    return null;
  }

  return getPrice(value, locale as string, currencyCode);
};
